export class CustomerPursesController {

  public static $inject = ['purses'];

  constructor(public purses: Array<InterACT.Interfaces.Purses.Purse>) {
  }
}